export interface IQuickLinkProps {
	value: string;
	label: string;
	children?: React.ReactNode;
}
export const quickLinksList: IQuickLinkProps[] = [
	{
		value: '1',
		label: 'Add a user',
	},
	{
		value: '2',
		label: 'Delete a User',
	},
	{
		value: '3',
		label: 'Manage Role',
	},

	{
		value: '4',
		label: 'Manage Workflow',
	},
	{
		value: '5',
		label: 'Security',
	},
	{
		value: '6',
		label: 'Notification',
	},
];
